import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import Button from '@material-ui/core/Button';
import React from 'react';
import { Link } from 'react-router-dom';
export default function LinkButton(props) {
    const { to, label, startIcon, disabled } = props;
    const button = (_jsx(Button, { startIcon: startIcon, variant: "contained", color: "primary", size: "medium", disabled: disabled, children: label }));
    if (disabled) {
        return button;
    }
    return (_jsx(Link, { to: to, style: { textDecoration: 'none' }, children: button }));
}
